import { makeAutoObservable, runInAction } from 'mobx'
import type { IEntitiesStore } from 'entities/EntitiesExport'

export class TrialProgressStore {
  private _loading = true

  constructor(private _entities: IEntitiesStore) {
    makeAutoObservable(this)
  }

  init = async () => {
    runInAction(() => {
      this._loading = true
    })

    await Promise.all([
      this._entities.usersStore.initPromise,
      this._entities.organizationStore.initPromise,
      this._entities.subscriptionStore.initPromise,
    ])

    runInAction(() => {
      this._loading = false
    })
  }

  get step() {
    return this._entities.organizationStore.trialEndsAtDaysNumber
  }

  get percent() {
    const total = this._entities.organizationStore.trialDaysMaxTotal
    const step = this.step

    return (step / total) * 100
  }

  get hide() {
    return (
      this._loading ||
      !this._entities.usersStore.user?.isAdminOrOwnerRole ||
      !this._entities.subscriptionStore.isTrial
    )
  }
}
